import { render, staticRenderFns } from "./ChatbotsPermissionManagement.vue?vue&type=template&id=c6f2d1b6&lang=pug"
import script from "./ChatbotsPermissionManagement.vue?vue&type=script&lang=js"
export * from "./ChatbotsPermissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6f2d1b6')) {
      api.createRecord('c6f2d1b6', component.options)
    } else {
      api.reload('c6f2d1b6', component.options)
    }
    module.hot.accept("./ChatbotsPermissionManagement.vue?vue&type=template&id=c6f2d1b6&lang=pug", function () {
      api.rerender('c6f2d1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/ChatbotsPermissionManagement.vue"
export default component.exports